import { setCookie, getCookie } from './cookies'
import { storageProxy } from './cache'
import { isDef } from './is'

const enum CacheKeys {
  TIMEZONE_TYPE = 'timezoneType',
  WAREHOUSE_TIMEZONE = 'warehouseTimezone',
  WAREHOUSE_SAVING_TIME = 'warehouseSavingTime',
}

export enum TimezoneType {
  BJ = '0',
  WH = '1',
}

/**
 * 时区类型
 * @param type BJ 北京时间  WH 仓库时间
 */
export const setTimezoneType = (type: TimezoneType) => {
  if (isDef(type)) {
    setCookie(CacheKeys.TIMEZONE_TYPE, type)
    storageProxy.set(CacheKeys.TIMEZONE_TYPE, type)
  }
}

export const getOrignTimezoneType = () => getCookie(CacheKeys.TIMEZONE_TYPE)

export const getTimezoneType = () =>
  (getCookie(CacheKeys.TIMEZONE_TYPE)?.toString() || TimezoneType.WH) as TimezoneType

export const setWarehouseTimezone = (warehouseTimezone: number) => {
  isDef(warehouseTimezone) && setCookie(CacheKeys.WAREHOUSE_TIMEZONE, warehouseTimezone)
}

export const getWarehouseTimezone = () => getCookie(CacheKeys.WAREHOUSE_TIMEZONE)

export const setWarehouseSavingTime = (savingTime: number) => {
  isDef(savingTime) && setCookie(CacheKeys.WAREHOUSE_SAVING_TIME, savingTime)
}

export const getWarehouseSavingTime = () => getCookie(CacheKeys.WAREHOUSE_SAVING_TIME)
